import { buildFeedbackIntegration, feedbackModalIntegration, feedbackScreenshotIntegration } from '@sentry-internal/feedback';

/** Add a widget to capture user feedback to your application. */
var feedbackSyncIntegration = buildFeedbackIntegration({
  getModalIntegration: function getModalIntegration() {
    return feedbackModalIntegration;
  },
  getScreenshotIntegration: function getScreenshotIntegration() {
    return feedbackScreenshotIntegration;
  }
});
export { feedbackSyncIntegration };